import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

interface BooleanFieldProps {
  field: string;
  defaultValue?: boolean;
  help?: string;
  onSubmit: (value: unknown) => void;
}

export function BooleanField({ field: _field, defaultValue, help, onSubmit }: BooleanFieldProps): React.ReactElement {
  const { t } = useTranslation();
  const [value, setValue] = useState(defaultValue ?? false);

  const handleSubmit = useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();
      onSubmit(value);
    },
    [value, onSubmit],
  );

  return (
    <form className="sp-field sp-field-boolean" onSubmit={handleSubmit}>
      <label className="sp-toggle-label">
        <div
          className={`sp-toggle${value ? ' sp-toggle-on' : ''}`}
          onClick={() => setValue((v) => !v)}
          role="switch"
          aria-checked={value}
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              setValue((v) => !v);
            }
          }}
        >
          <div className="sp-toggle-track" />
          <div className="sp-toggle-thumb" />
        </div>
        <span className="sp-toggle-text">{value ? t('fields.enabled') : t('fields.disabled')}</span>
      </label>
      {help && <span className="sp-field-help">{help}</span>}
      <button className="sp-field-submit" type="submit">
        {t('fields.submit')}
      </button>
    </form>
  );
}
